// App settings. A deployed container sets them at start-up (window.__XPED_CONFIG__ from /config.js), so one
// image serves every environment; in development they come from the VITE_* values in .env.local.

const runtime = (typeof window !== 'undefined' && window.__XPED_CONFIG__) || {};
const env = import.meta.env;

export const config = {
  apiUrl: runtime.apiUrl ?? env.VITE_API_URL ?? '/api',
  oidcAuthority:
    runtime.oidcAuthority ??
    env.VITE_OIDC_AUTHORITY ??
    'https://login.xpedition2.dev.rgsit.cloud/realms/xpedition2-dev',
  oidcClientId: runtime.oidcClientId ?? env.VITE_OIDC_CLIENT_ID ?? 'xpedition2-web',
  authDisabled: runtime.authDisabled ?? env.VITE_AUTH_DISABLED === 'true',
} as const;
